import React from 'react';

const Introduction = () => (
  <div className="introduction">
    <p>Dear Customer,</p>
    <p>
      As you may be aware, governments around the world have introduced laws to help protect the integrity of tax systems.
      Under these laws, we are required to collect and report certain tax information about our customers to the relevant tax authorities.
    </p>
    <p>
      These laws are known as the Foreign Account Tax Compliance Act (&lsquo;FATCA&rsquo;) and Common Reporting Standard (&lsquo;the CRS&rsquo;).
      You can read more about FATCA and CRS requirements here.
    </p>
    <p>
      To that end, we request that you respond to the following questions which will ensure that we hold accurate and up to date information about your tax
      residency and can direct you to the relevant self-certification forms that you will be required to complete, electronically sign and submit.
    </p>
    <p>Should you have any technical question while completing this module, please visit the “help” menu by clicking on the “help” button at the bottom left hand corner of the screen.</p>
    <p>Should you have any further question on how FATCA and CRS laws may affect you, please speak to your tax advisor as we do not provide tax advice.</p>
    <p>To begin the process, please click “Next” in the bottom right corner of your screen.</p>
  </div>
);

export default Introduction;
